export const defaultLogo = "https://cdn.simulanis.io/sso/logos/default_simulanis.png";
export const applicationId = "973813b6-bab0-4cf4-a10e-a69d343eab27";
export const UNO_URL = "https://api.simulanis.io";
